export const appRootId = "__pikcloud"

export const appBuildAssetsDir = "/pikcloud/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"},{"content":"IE=edge","http-equiv":"x-ua-compatible"},{"name":"renderer","content":"webkit"},{"name":"build-id","content":"2fc056c2"},{"name":"build-time","content":"Tue, 22 Jul 2025 07:34:22 GMT"}],"link":[{"href":"/apple-touch-icon.png","rel":"apple-touch-icon","sizes":"180x180"},{"href":"/favicon-32x32.png","rel":"icon","sizes":"32x32","type":"image/png"},{"href":"/favicon-16x16.png","rel":"icon","sizes":"16x16","type":"image/png"},{"href":"/manifest.json","rel":"manifest"}],"style":[],"script":[{"src":"/scripts/track.js?e73373f9"},{"src":"/register.js?1ea83a75","async":true},{"src":"/scripts/gtag.js?f349046a","async":true},{"src":"/scripts/clarity.js?a2c2a69e","async":true},{"src":"/scripts/adjust.min.js?4874996d","async":true},{"src":"/scripts/set-style.js?b8e6c49c","async":true}],"noscript":[]}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appRootAttrs = {"id":"__pikcloud"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__pikcloud'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true